import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { SettingElementField } from "@/features/settings/components/setting-element-field";
import { useLoginContext } from "@/features/auth/contexts/login-context";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { useLogout } from "@/features/auth/hooks/use-logout";
import { useTradeJumpContext } from "@/features/trade-jump/contexts/trade-jump-context";

interface Props {
  onTapCloseModal: () => void;
}

// 利用者アカウントモーダル
export const SettingsModal = ({ onTapCloseModal }: Props) => {
  const {
    userName,
  } = useLoginContext();
  const {
    setOpenHomeModal,
  } = useModalContext();
  const { syncJump } = useTradeJumpContext();
  const { onClickLogout } = useLogout();

  return (
    <BasePageModal
      title="アカウント"
      handleClose={() => {
        onTapCloseModal();
      }}
      className="md-user-menu"
    >
      <h2>
        {!syncJump && (
        <><strong>{userName}</strong>がログイン中</>
        )}
      </h2>
      <ul>
        {!syncJump && (
        <SettingElementField
          title="ユーザー名の変更"
          handleClick={() => setOpenHomeModal("UserInfo")}
          className="btn-pedit"
        />
        )}

        {!syncJump && (
        <SettingElementField
          title="メールアドレスの変更"
          handleClick={() => setOpenHomeModal("UserId")}
          className="btn-mail"
        />
        )}

        {!syncJump && (
        <SettingElementField
          title="パスワードの変更"
          handleClick={() => setOpenHomeModal("UserPassword")}
          className="btn-pass"
        />
        )}

        {!syncJump && (
        <SettingElementField
          title="メールの配信設定"
          handleClick={() => setOpenHomeModal("MailSettings")}
          className="btn-mail btn-send-mail"
        />
        )}

        {!syncJump && (
        <SettingElementField
          title="2段階認証の設定"
          handleClick={() => setOpenHomeModal("TwoStepAuth")}
          className="btn-2factor"
        />
        )}

        {!syncJump && (
        <SettingElementField
          title="ユーザーの統合"
          handleClick={() => setOpenHomeModal("UsersIntegrationInput")}
          className="btn-integrat"
        />
        )}

        <SettingElementField
          title="ログイン履歴"
          handleClick={() => setOpenHomeModal("LoginHistory")}
          className="btn-history"
        />

        {!syncJump && (
        <SettingElementField
          title="アカウント削除"
          handleClick={() => setOpenHomeModal("DeleteUser")}
          className="btn-deluser"
        />
        )}

        <SettingElementField
          title="ログアウト"
          handleClick={() => onClickLogout()}
          className="btn-logout"
        />
      </ul>
    </BasePageModal>
  );
};
